<div
    tabindex="-1"
    id="myModal"
    role="dialog"
    class="modal fade in">
    <div class="backdrop"></div>
    <!-- Modal Dialog starts here -->
    <div
        data-show="true"
        role="document"
        class="modal-dialog"
        [class]="modalSize">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    type="button"
                    class="close"
                    (click)="close()"
                    title="Close">
                    <i class="nlrp-icon nlrp-icon-close"></i>
                </button>
                <h3 class="modal-title">{{title}}</h3>
            </div>
            <form
                id="fileUploadForm"
                name="fileUploadForm"
                novalidate
                autocomplete="off">
                <div class="modal-body">
                    @if (lodgementErrorText) {
                        <div class="well">
                            <span>{{lodgementErrorText}}</span>
                        </div>
                    }
                    @if (lodgementErrorList.length > 0) {
                        <table class="table table-hover table-striped">
                            <thead>
                                <tr class="default">
                                    <td>Message</td>
                                </tr>
                            </thead>
                            <tbody>
                                @for (lodgementError of lodgementErrorList; track lodgementError; let i = $index) {
                                    <tr>
                                        <td
                                            [nlrTooltip]="lodgementError.detail"
                                            [nlrTooltipPosition]="'bottom'">
                                            <div class="alias-selector">
                                                <div>{{lodgementError.summary}}</div>
                                            </div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    }
                </div>
            </form>
            <div class="modal-footer">
                <div class="form-group">
                    <button
                        type="button"
                        class="btn btn-default nlr-btn-sm"
                        (click)="close()">
                        OK
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
